import { shrpaApi } from "./axios";
import moment from "moment";

// Types
import { PhotoGallerySource, PhotoGalleryCustomerData, PhotoGalleryTitleAndComment } from "@contracts/photosPageData";

export default {
  /**
   * The Uploading Date is required to determine whether to create a new group when the customer uploads new assets outside a group
   */
  async createMyUploadsGroup(
    customerId: string,
    title: string,
    comment = null as string | null,
    currentOperationSource: PhotoGallerySource,
    photoCredit = null as string | null,
    locationExternalId = null as string | null,
    locationName = null as string | null,
    address = null as string | null,
    city = null as string | null,
    state = null as string | null,
    country = null as string | null
  ): Promise<PhotoGalleryCustomerData> {
    const uri = `/photo-gallery/v2/${customerId}/my-uploads/photo-groups`;

    const payload = JSON.stringify({
      title,
      comment,
      photoCredit,
      clientSideDateTime: moment().format(),
      createdSource: currentOperationSource,
      locationExternalId,
      locationName,
      address,
      city,
      state,
      country,
    });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await shrpaApi.post<PhotoGalleryCustomerData>(uri, payload, config);

    return data;
  },

  async updateMyUploadsGroupCommentAndTitle(
    customerId: string,
    photoGalleryId: string,
    title: string,
    comment: string | null,
    currentOperationSource: PhotoGallerySource | null,
    photoCredit = null as string | null,
    locationExternalId = null as string | null,
    locationName = null as string | null,
    address = null as string | null,
    city = null as string | null,
    state = null as string | null,
    country = null as string | null
  ): Promise<PhotoGalleryCustomerData> {
    let uri = `/photo-gallery/v2/${customerId}/my-uploads/photo-groups/${photoGalleryId}/comment-and-title`;
    if (currentOperationSource) {
      uri += `?currentOperationSource=${currentOperationSource}`;
    }

    const payload = JSON.stringify({
      title,
      comment,
      photoCredit,
      locationExternalId,
      locationName,
      address,
      city,
      state,
      country,
    } as PhotoGalleryTitleAndComment);

    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await shrpaApi.put<PhotoGalleryCustomerData>(uri, payload, config);

    return data;
  },

  async addPhotosToGroup(customerId: string, photoGalleryId: string, photoIds: Array<string>, currentOperationSource?: PhotoGallerySource | null): Promise<void> {
    let uri = `/photo-gallery/v2/${customerId}/my-uploads/photo-groups/${photoGalleryId}/photos`;
    if (currentOperationSource) {
      uri += `?currentOperationSource=${currentOperationSource}`;
    }
    const payload = JSON.stringify(photoIds);
    const config = { headers: { "Content-Type": "application/json" } };

    await shrpaApi.put(uri, payload, config);
  },

  async deleteMyUploadsGroup(customerId: string, groupId: string, currentOperationSource?: PhotoGallerySource | null): Promise<void> {
    let uri = `/photo-gallery/v2/${customerId}/my-uploads/photo-groups/${groupId}`;
    if (currentOperationSource) {
      uri += `?currentOperationSource=${currentOperationSource}`;
    }

    await shrpaApi.delete<any>(uri);
  },

  async deleteMyUploadsGroupPhotos(customerId: string, photoIds: Array<string>, currentOperationSource?: PhotoGallerySource | null): Promise<void> {
    let uri = `/photo-gallery/v2/${customerId}/my-uploads/photos`;
    if (currentOperationSource) {
      uri += `?currentOperationSource=${currentOperationSource}`;
    }
    const payload = JSON.stringify(photoIds);
    const config = { headers: { "Content-Type": "application/json" } };

    await shrpaApi.delete<any>(uri, { data: payload, ...config });
  },

  /**
   * The Uploading Date is required to determine whether to create a new group when the customer uploads new assets outside a group
   */
  async upsertMyUploadsGroupPhotos(customerId: string, photoIds: Array<string>, currentOperationSource?: PhotoGallerySource | null): Promise<PhotoGalleryCustomerData> {
    let uri = `/photo-gallery/v2/${customerId}/my-uploads/photos`;
    if (currentOperationSource) {
      uri += `?currentOperationSource=${currentOperationSource}`;
    }

    const payload = JSON.stringify({
      photoIds,
      ClientSideDateTime: moment().format(),
    });

    const config = { headers: { "Content-Type": "application/json" } };

    const { data } = await shrpaApi.put<PhotoGalleryCustomerData>(uri, payload, config);

    return data;
  },

  async movePhotosToAGallery(customerId: string, photoIds: Array<string>, galleryIdToMoveTo: string): Promise<void> {
    const uri = `/photo-gallery/v2/${customerId}/my-uploads/photos/move`;

    const payload = JSON.stringify({
      photoIds,
      galleryIdToMoveTo,
      clientSideDateTime: moment().format(),
    });

    const config = { headers: { "Content-Type": "application/json" } };

    await shrpaApi.put<Array<string>>(uri, payload, config);
  },
};
